import type RoutePathsWithTemplate from '../../../../shared/types/routing/RoutePathsWithTemplate';

const routeSegmentRequiresReplacement = (
  route: RoutePathsWithTemplate,
) => {
  return typeof route === 'string' ? route.includes(':') : false;
};

export default routeSegmentRequiresReplacement;
